import React from 'react';
import Modal from '../../../../components/shareable/modal';
import { Download, FileX, Loader } from 'lucide-react';

const PdfModal = ({ isOpen, onClose, pdfUrl, quoteNumber }) => {

  const handleDownloadPdf = () => {
    if (!pdfUrl) return;
    
    // Create a temporary link to trigger download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.target = '_blank';
    link.download = `quote-${quoteNumber}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal isOpen={isOpen} width='5xl' height='5xl' onClose={onClose}>
      <div className="flex flex-col h-full">
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-red-700">Quote PDF</h2>
        </div>
        
        <div className="flex-grow overflow-hidden flex items-center justify-center" style={{ minHeight: '70vh' }}>
          {pdfUrl === null ? (
            // Loading state
            <div className="flex flex-col items-center justify-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 p-8">
              <Loader className="h-16 w-16 text-red-500 mb-4 animate-spin" />
              <div className="text-center">
                <h3 className="text-lg font-medium text-gray-900 mb-2">Loading PDF</h3>
                <p className="text-gray-500">
                  Please wait while we retrieve the PDF for quote number: <span className="font-medium">{quoteNumber || 'this quote'}</span>
                </p>
              </div>
            </div>
          ) : pdfUrl ? (
            // PDF available
            <div className="h-full w-full border border-gray-200 rounded-lg overflow-hidden shadow-md">
              <iframe
                src={`${pdfUrl}#view=FitH&toolbar=0&navpanes=0&scrollbar=0&zoom=80`}
                className="w-full h-full"
                title="Quote PDF"
                style={{ minHeight: '65vh' }}
              />
            </div>
          ) : (
            // PDF not available state
            <div className="flex flex-col items-center justify-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 p-8">
              <FileX className="h-16 w-16 text-red-500 mb-4" />
              <div className="text-center">
                <h3 className="text-lg font-medium text-gray-900 mb-2">PDF Not Available</h3>
                <p className="text-gray-500 mb-4">
                  No PDF exists for quote number: <span className="font-medium">{quoteNumber || 'this quote'}</span>
                </p>
              </div>
            </div>
          )}
        </div>
        
        {/* Center bottom download button - only shown when PDF is available */}
        {pdfUrl && (
          <div className="flex justify-center">
            <button onClick={handleDownloadPdf} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors" >
              <Download size={16} />
              <span>Download PDF</span>
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PdfModal;
